<template>
	<div id="clientAccessibility" class="jc-view">
		<JuniperPageHeader
			:back="'/juniper/clients/edit/' + clientId"
			:title="client ? client.name : ''"
			subtitle="Accessibility"
		/>

		<div v-if="loading" class="text-center py-5">
			<div class="spinner-border text-primary" role="status">
				<span class="visually-hidden">Loading...</span>
			</div>
		</div>

		<div v-else class="cax-content mt-3">
			<ClientAuditsTab :client-id="clientId" :main-dashboard="mainDashboard" />
		</div>
	</div>
</template>

<script>
import juniperApi from '@/api/juniperApi'
import ClientAuditsTab from '@/components/juniper/ada-auditor/ClientAuditsTab.vue'

/**
 * Accessibility page for a juniper client (Tools & Insights → Accessibility).
 * Hosts the audit engine / scan plan / reports panel that used to live in
 * Settings → Audits; ClientAuditsTab loads and saves its own settings, this
 * page only supplies the client's main_dashboard option.
 */
export default {
	name: 'ClientAccessibility',
	components: { ClientAuditsTab },
	data() {
		return {
			client: null,
			mainDashboard: 'town-web-dashboard',
			loading: true,
		}
	},
	computed: {
		clientId() {
			return this.$route.params.id
		},
	},
	created() {
		this.load()
	},
	methods: {
		async load() {
			this.loading = true
			try {
				const [clientRes, optionsRes] = await Promise.all([
					juniperApi.get('/clients/' + this.clientId),
					juniperApi.post('/options/' + this.clientId),
				])
				this.client = clientRes.data
				this.mainDashboard = (optionsRes.data && optionsRes.data.main_dashboard) || 'town-web-dashboard'
			} catch (e) {
				console.error('Failed to load client', e)
			} finally {
				this.loading = false
			}
		},
	},
}
</script>

<style scoped>
.cax-content {
	padding: 15px;
}
</style>
